import { render, staticRenderFns } from "./MyTask.vue?vue&type=template&id=4e8df225&scoped=true&"
import script from "./MyTask.vue?vue&type=script&lang=js&"
export * from "./MyTask.vue?vue&type=script&lang=js&"
import style0 from "./MyTask.vue?vue&type=style&index=0&id=4e8df225&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8df225",
  null
  
)

export default component.exports